/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingServicedeskSelfServiceSetupRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskSelfServiceSetupRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServicedeskSelfServiceSetupComponent, {
	LazyProjectSettingServicedeskSelfServiceSetup,
} from './ui/service-desk-self-service-setup/ServicedeskSelfServiceSetupComponent.tsx';

export const projectSettingServicedeskSelfServiceSetupRouteEntry: ReturnType<typeof createEntry> =
	createEntry(projectSettingServicedeskSelfServiceSetupRoute, () => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-self-service-setup-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: ServicedeskSelfServiceSetupComponent,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingServicedeskSelfServiceSetup],
		perfMetricKey: 'jsm-self-service-setup-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}));
